module.exports = __webpack_public_path__ + "static/img/tip-wrap.0e3ce6c3.png";